/* eslint @typescript-eslint/explicit-function-return-type: off */

export const indexPath = (projectId) =>
  `/projects/${projectId}/commission_configs`;
export const createPath = indexPath;
export const detailsPath = (projectId, configId) =>
  `/projects/${projectId}/commission_configs/${configId}`;
export const updatePath = detailsPath;
export const destroyPath = detailsPath;
